import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { ICredentialSummary } from '../types/ICredentialSummary';

export interface ListCredentialSummariesParams {
    targetClass: string;
}

export interface IListCredentialSummariesResult extends IResult {
    credentialSummaries: ICredentialSummary[];
}

export class ListCredentialSummariesRequest extends Request<ListCredentialSummariesParams, IListCredentialSummariesResult> {
  constructor(params: ListCredentialSummariesParams) {
    super('listCredentialSummaries', params);
  }
}